module.exports = __webpack_public_path__ + "static/media/festes.fa32f005.jpg";